import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import tokenService from "../_services/token.service";
import { checkIfSuperuserToken } from "../utils/check-if-superadmin-token";

const Forbidden = () => (
  <div style={{ padding: "48px 24px", textAlign: "center" }}>
    <h1 style={{ fontSize: "20px", fontWeight: 700, marginBottom: "8px" }}>
      403 - Acceso denegado
    </h1>
    <p style={{ color: "#6b7280", marginBottom: "16px" }}>
      Solo los superusuarios pueden acceder al panel de administración.
    </p>
    <a
      href="/"
      style={{
        display: "inline-block",
        padding: "8px 14px",
        borderRadius: "8px",
        background: "#111827",
        color: "#ffffff",
        textDecoration: "none",
        fontSize: "14px",
        fontWeight: 600,
      }}
    >
      Ir al login
    </a>
  </div>
);

export default function RequireSuperuser({
  children,
}: {
  children: JSX.Element;
}) {
  const location = useLocation();
  const token = tokenService.getLocalAccessToken();

  if (!token) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (!checkIfSuperuserToken()) {
    return <Forbidden />;
  }

  return children;
}
